const on_dev = false;

module.exports = {
  on_dev,
  // dev_access_token: "d765a378-ca61-4a4d-8551-658c832df44d",
  /*
  lineDevProfile: {
    userId: "U8ab2fad5affd3e344a9635e30e83fcfe",
    displayName: "Pratch Sanguansak",
    pictureUrl:
      "https://profile.line-scdn.net/0m07dfed987251d4e7903bb8667a7af0c77bb6d67ac8ff",
  },
  */
  lineDevProfile: {
    userId: "U8ab2fad5affd3e344a9635e30e83fcfe",
    displayName: "ภัควรรธน์ ส่งกุล",
    pictureUrl:
      "https://profile.line-scdn.net/0hPC-eatdnD2wAHB0dVtFxE3BMDAYjbVZ-f34TCjEUU1hvLUxqKXxJDT0aAl8_eU0yeHJFDDYdUl4MD3gKHkrzWAcsUVs6LUE-LHlIjQ",
  },
  liffId: "1660851296-z7YmVBxe",
  endpoint: {
    tonkla:
      on_dev === true
        ?   "http://localhost:3001"
          // "https://tonkla-backend.azurewebsites.net"
        : "https://tonkla-backend.azurewebsites.net",
    file: "https://tca.tonkla.ac.th/upload",
  },
  cookie_name: "tonkla-parents-cookie",
};
